// assets
import { ToolOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  ToolOutlined,
  UnorderedListOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const applications = {
  id: 'applications_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'applications',
      title: <FormattedMessage id="applications" />,
      type: 'collapse',
      icon: icons.ToolOutlined,
      children: [
        { id: 'scripts', title: <FormattedMessage id="scripts" />, icon: icons.UnorderedListOutlined, url: '/scripts', type: 'item' },
        { id: 'tools', title: <FormattedMessage id="tools" />, icon: icons.ToolOutlined, url: '/tools', type: 'item' }
      ]
    }
  ]
};

export default applications;
